<template>
  <div v-show="isShow" class="dash_admin_box">
    <div style="display: block" class="dash_admin_box dash_admin_03">
      <!-- 검색 Wrap -->
      <div class="option_wrap">
        <div class="search_filter">
          <form>
            <div class="option_date">
              <date-picker
                id="startedDate"
                v-model="listParam.beginDate"
                :lang="getLang"
                value-type="format"
                format="YYYY-MM-DD"
                type="date"
              />
              <span>~</span>
              <date-picker
                id="endedDate"
                v-model="listParam.endDate"
                :lang="getLang"
                value-type="format"
                format="YYYY-MM-DD"
                type="date"
              />
            </div>
            <div class="option_date w100">
              <input
                v-model="listParam.title"
                type="text"
                placeholder="제목 검색"
                @keyup.enter="onClickSearch"
              />
            </div>

            <div class="search_button">
              <button type="button" @click="onClickSearch">검색</button>
            </div>
          </form>
        </div>
      </div>

      <!-- 검색 Wrap //-->

      <div class="dash_admin_box_table">
        <table>
          <thead>
            <tr>
              <th>no</th>
              <th>제목</th>
              <th>등록일</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="pageParam.total === 0">
              <td colspan="3">검색 결과가 없습니다.</td>
            </tr>
            <template v-if="pageParam.total !== 0">
              <tr v-for="(item, index) in pageParam.content" :key="index">
                <td>
                  {{ index + 1 }}
                </td>

                <td
                  style="cursor: pointer; color: aqua"
                  @click="viewDetail(item.id)"
                >
                  {{ item.title }}
                </td>

                <td>
                  {{ dayFormat(item.regDt) }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <pagination
        :page-param="pageParam"
        :list-cnt="listParam.size"
        @pageCallback="pageCallback"
      />
      <popup-create-notice
        ref="popupCreateNotice"
        @confirmCallBack="confirmCallBack"
      />
      <popup-detail-notice ref="popupDetailNotice" />
      <popup-update-notice
        ref="popupUpdateNotice"
        @confirmCallBack="confirmCallBack"
      />
      <confirm :param="confirmParam" @deleteCallback="deleteCallback" />
    </div>
  </div>
</template>
<script>
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import Pagination from "./layout/Pagination.vue";
import { getToday, toDayFormatAddDay, dayFormat } from "../utils/date";
import { mapGetters } from "vuex";
import BoardApi from "../api/BoardApi";
import SiteApi from "../api/SiteApi";
import { USER_ID } from "../const";
import PopupCreateNotice from "./detail/PopupCreateNotice.vue";
import PopupDetailNotice from "./detail/PopupDetailNotice.vue";
import PopupUpdateNotice from "./detail/PopupUpdateNotice.vue";
import Confirm from "./Confirm.vue";
export default {
  name: "PopupQnaList",
  components: {
    Pagination,
    DatePicker,
    PopupCreateNotice,
    PopupDetailNotice,
    PopupUpdateNotice,
    Confirm,
  },
  props: {
    siteId: {},
  },
  data: () => {
    return {
      companyList: [],
      pageParam: { content: [] },
      listParam: {
        page: 1,
        size: 10,
        beginDate: toDayFormatAddDay(-7),
        endDate: getToday(),
        title: null,
        type: "suggest",
        sysType: "qtest",
      },
      isShow: false,
      allSelected: false,
      fileIds: [],
      accessSiteList: [],
      selectSiteId: [],
      adminId: localStorage.getItem(USER_ID),
      confirmParam: {
        title: "",
        msg: "",
        isShow: false,
      },
      noticeId: null,
      paramSiteId: null,
    };
  },
  computed: {
    ...mapGetters(["getLang"]),
  },
  created() {},
  async mounted() {},
  beforeDestroy() {},
  methods: {
    getToday: getToday,
    dayFormat: dayFormat,
    async init() {
      const response = await SiteApi.getSiteYearPlan(this.siteId);
      this.siteYearPlanList = response;
      if (this.siteYearPlanList.length > 0) {
        const today = this.getToday();
        const findSiteYear = this.siteYearPlanList.filter(
          (siteYear) => siteYear.beginDay <= today && siteYear.endDay >= today
        );
        if (findSiteYear.length > 0) {
          this.listParam.beginDate = findSiteYear[0].beginDay;
        } else {
          this.listParam.beginDate = toDayFormatAddDay(-7);
        }
      }
      this.getSiteList();
      this.fetchHistoryFile();
    },
    onClickSearch() {
      this.listParam.page = 1;
      this.fetchHistoryFile();
    },
    async getSiteList() {
      const response = await SiteApi.getSiteList();
      this.accessSiteList = response;
    },
    async fetchHistoryFile() {
      //TODO 구해야 됨
      // this.listParam.siteId = this.paramSiteId;

      const response = await BoardApi.boardList(this.listParam);
      response.size = this.listParam.size;
      this.pageParam = response;
      this.pageParam.content.forEach((item) => {
        this.accessSiteList.forEach((site) => {
          if (item.siteId === site.id) {
            item.siteName = site.name;
          }
        });
      });
      console.log(response);
    },
    pageCallback(page) {
      this.listParam.page = page;
      this.fetchHistoryFile();
    },
    contentSubStr(str) {
      if (str) {
        str = str.replace(/<[^>]*>?/g, "");
        if (str.length > 10) {
          str = str.substr(0, 8) + "...";
        }
      }
      return str;
    },
    imgFaults(item) {
      var url = "/img/common/";
      if (item) url += "bullet_red_icon.png";
      else url += "bullet_green_icon.png";

      return url;
      //bullet_green_icon.png
      //bullet_red_icon.png
    },
    getNumber(index) {
      this.pageParam.total -
        ((this.listParam.page - 1) * this.listParam.size + index);
    },

    sliceTime(time) {
      if (time) return time.slice(0, 5);
      return "";
    },
    enter2Br(str) {
      if (!str) return "";
      return str.replace(/(?:\r\n|\r|\n)/g, "<br />");
    },
    open() {
      this.init();
      this.isShow = true;
    },
    close() {
      this.listParam.title = null;
      this.isShow = false;
    },
    selectAll() {
      this.fileIds = [];
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        this.pageParam.content.forEach((element) => {
          this.fileIds.push(element.fileId);
        });
      }
    },
    select() {
      this.allSelected = false;
    },
    async onClickDownload() {
      const fileArray = [];
      if (this.fileIds.length === 0) {
        this.$toast.info("파일을 선택하세요.");
        return;
      }

      this.fileIds.forEach((fileId) => {
        this.pageParam.content.forEach((item) => {
          if (fileId === item.fileId) {
            const file = {};
            file.fileId = item.fileId;
            file.fileNo = item.fileNo;
            fileArray.push(file);
          }
        });
      });

      const fileName = "시험계획서";
      await HistoryFileApi.multiDownload(fileArray, fileName);
    },
    changeSite() {
      this.fetchHistoryFile();
    },
    regist() {
      const param = {
        accessSiteList: this.accessSiteList,
        selectSiteId: this.selectSiteId,
      };
      this.$refs.popupCreateNotice.open(param);
    },
    confirmCallBack() {
      this.fetchHistoryFile();
      this.init();
    },
    async viewDetail(id) {
      const response = await BoardApi.detail(id);
      response.content.selectSiteId = this.selectSiteId;
      response.content.accessSiteList = this.accessSiteList;
      this.$refs.popupDetailNotice.open(response.content);
    },
    async update(id) {
      const response = await BoardApi.detail(id);
      response.content.selectSiteId = this.selectSiteId;
      response.content.accessSiteList = this.accessSiteList;
      this.$refs.popupUpdateNotice.open(response.content);
    },
    remove(noticeId) {
      this.confirmParam.title = "공지사항";
      this.confirmParam.msg = "삭제 하시겠습니까?";
      this.confirmParam.isShow = true;
      this.noticeId = noticeId;
    },
    deleteCallback() {
      BoardApi.remove(this.noticeId).then(() => {
        this.init();
        this.$toast.success("삭제 되었습니다.");
      });
    },
  },
};
</script>
